import type { ReactNode } from 'react';

export const symbol_passport: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M370-220h220q13 0 21.5-8.5T620-250q0-13-8.5-21.5T590-280H370q-13 0-21.5 8.5T340-250q0 13 8.5 21.5T370-220Zm110-120q83 0 141.5-58.5T680-540q0-83-58.5-141.5T480-740q-83 0-141.5 58.5T280-540q0 83 58.5 141.5T480-340Zm0-67q-8-11-17-36.5T451-510h58q-3 41-12 66.5T480-407Zm-72-13q-24-15-41-38t-23-52h47q2 25 6 47.5t11 42.5Zm144 0q7-20 11-42.5t6-47.5h47q-6 29-23 52t-41 38ZM344-570q6-29 23-52t41-38q-7 20-11 42.5t-6 47.5h-47Zm107 0q3-41 12-66.5t17-36.5q8 11 17 36.5t12 66.5h-58Zm118 0q-2-25-6-47.5T552-660q24 15 41 38t23 52h-47ZM190-80q-12.75 0-21.37-8.63Q160-97.25 160-110v-740q0-12.75 8.63-21.38Q177.25-880 190-880h550q24.75 0 42.38 17.62Q800-844.75 800-820v680q0 24.75-17.62 42.37Q764.75-80 740-80H190Zm30-60h520v-680H220v680Zm0 0v-680 680Z"
		/>
	</svg>
);
